import React from "react";
import "./About.css";
import mbaliProfile from "../assets/mbali-no-background.png"; // your PNG image

const About = () => {
  return (
    <section id="about" className="about">
      {/* Background image container */}
      <img
        className="about-image"
        src={mbaliProfile}
        alt="About Mbali"
      />

      {/* Bottom overlay */}
      <div className="about-overlay">
        <div className="about-content-background">
          <div className="about-content">
            <h2 className="about-title">About Mbali</h2>

            <p className="about-text">
              My name is Mbali Mapaila. Fleur is a French name meaning flower, which is a direct translation of my name. I am a part time photographer based in Middelburg Mpumalanga. My love for taking pictures started in 2003 when I started working and travelling. I bought myself a 2-megapixel camera and I found myself taking pictures everywhere I went. I eventually upgraded my camera to a DSLR, that is when I started being intrigued by the camera and all the settings. I then decided to study photography at the College of Digital Photography to learn more about it and enhance my skill.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
